import React from "react";

const Seperator = () => {
    return (<>
        <hr className="seperator w-100" />
    </>)
}
export default Seperator;